import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import styled from "styled-components";

function DriverIsExist() {
    return (
        <AlertWrapper>
            <TitleWrapper>
                <InfoOutlinedIcon
                    color="info"
                    fontSize="16px"
                />
                <Title>The driver is already registered with Illa</Title>
            </TitleWrapper>
            <Detailes>Review the data and then add the driver to your account</Detailes>
        </AlertWrapper>
    );
}
const AlertWrapper = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #e6f1fa;
    padding: 1.5em;
    margin-bottom: 20px;
`;
const TitleWrapper = styled.div`
    display: flex;
    color: #0077cc;
    align-items: baseline;
    margin-bottom: 10px;
`;
const Title = styled.h2`
    color: #0077cc;
    font-weight: 500;
    font-size: 25px;
    margin-inline: 10px;
`;
const Detailes = styled.p`
    font-size: 20px;
    font-weight: 500;
    color: #343741;
`;

export default DriverIsExist;
